
export const exceptionsInOrderAssignment = {
    columns: [
        {
            title: 'N° Despacho',
            name: 'identifier',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.identifier
        },
        {
            title: 'Linea',
            name: 'value',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.value
        },
        {
            title: 'N° Asignados',
            name: 'location',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.location
        },
        {
            title: 'Observaciones',
            name: 'issue',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.issue
        },
        {
            title: 'Pedidos no procesados',
            name: 'orders',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.orders
        }
    ]
};
